<template>
  <div>
    <div class="mt-2">
        <div class="relative mt-1 rounded-md shadow-sm" @click="focusMoney">
        <div class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
            <span class="text-gray-500 sm:text-sm"></span>
        </div>
        <input id="price" autocomplete="off" inputmode="numeric" class="block w-full h-14 font-medium border-gray-400 focus:outline-none focus:border-transparent focus:ring-purple-600 rounded-md pl-3 pr-24" @input="formatMoney" v-model="form.money" :class="{ 'border-input-success': form.money.length > 0 ? true : false, 'border-input-error': click_check ? form.money.length < 1 ? true : false : false }" style="border: 2px solid #D6D9DB;" placeholder="Số tiền cần vay" />
        
        <!-- <input type="text" name="price" id="price" class="block w-full rounded-md border-gray-300 pl-7 pr-12 focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm" placeholder="0.00" /> -->
        <div v-if="form.money" class="absolute inset-y-0 left-10 flex items-center">
            <label for="currency" class="sr-only">Currency</label>
            <span class="font-medium border-transparent " :class="{ 'color-success': form.money.length > 0 ? true : false, 'color-error': click_check ? form.money.length < 1 ? true : false : false }"> triệu đồng </span>
            <!-- <select id="currency" name="currency" class="h-full rounded-md border-transparent bg-transparent py-0 pl-2 pr-7 text-gray-500 focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
            <option>Triệu đồng</option>
            
            </select> -->
        </div>
        </div>
        <div v-if="click_check ? form.money.length < 1 ? true : false : false" class="text-right text-red-700">Số tiền không được để trống</div>
    </div>

    <div class="mt-2 relative" @click="showText" data-tip2="Lưu ý: sử dụng thuê bao viettel">
        <input @input="formatPhone" inputmode="numeric" v-model="form.phone" class="w-full h-14 focus:outline-none focus:border-transparent focus:ring-purple-600 rounded-md pl-3 pt-1 pb-1 pr-3 color-bold-vmain font-medium" :class="{ 'border-input-success': checkPhone, 'border-input-error': phone_error }" style="border: 2px solid #D6D9DB;"  placeholder="Số điện thoại của bạn" />
        <div v-if="phone_error" class="text-right text-red-700">
            <span v-if="form.phone.length < 1">
                Số điện thoại không được để trống
            </span>
            <span v-else>
                Số điện thoại không hợp lệ, vui lòng nhập lại
            </span>
            
        </div>
        <div id="show_text" class="absolute top-1 right-1 text-white p-1 w-3/5">
            
        </div>
        <!-- <div v-if="click_check && phone_error ? form.phone.length < 1 ? true : false : false" class="text-right text-red-700">Số điện thoại không được để trống</div> -->
    </div>
    <div class="mt-4">
        <div :class="{'bg-color-vmain' : input_check , 'bg-vmain-disable' : !input_check }"  class=" text-white  rounded-md text-center">
            <button class="font-bold-vmain p-3 w-full" :disabled="!input_check" @click="showResult"  ><b-spinner v-if="loading_otp" small type="grow"></b-spinner>Nhận khoản vay</button>
        </div>
    </div>

    <div class="w-full mt-8">
        <div class="w-full flex flex-row">
            <div
                class="w-6 h-6 cursor-pointer"
                @click="input_check=!input_check"
            >
                <img
                    v-if="input_check"
                    src="@/assets/checked-box.svg"
                    class="w-full h-full"
                />
                <img
                    v-else
                    src="@/assets/check-box.svg"
                    class="w-full h-full"
                />
            </div>
            <div class="flex flex-1 ml-3">
                <div class="text-sm text-[#808080]">
                    Tôi đã đọc, hiểu và đồng ý với <span @click="$router.push({ name: 'VPolicy' })"  class="font-bold cursor-pointer"> điều khoản sử dụng dịch vụ</span>  
                </div>
            </div>
        </div>
    </div>

    <!-- <div class="mt-3 text-center text-sm">
        Bằng việc nhấn nút "Nhận khoản vay", đồng nghĩa bạn đã đọc và đồng ý với <span @click="$router.push({ name: 'VPolicy' })" class="font-bold"> điều khoản sử dụng dịch vụ</span> của Vclick
    </div> -->

  </div>
</template>

<script>
export default {
    props:['form','clickShowModal', 'loading_otp'],
    data() {
        return {
            phone_error: false,
            click_check: false,
            checkPhone: undefined,
            input_check: true
        }
    },
    methods: {
        showResult(){
            //removeToken()
            this.click_check = true

            this.formatPhone()
            if(this.checkPhone && this.form.money.length > 0) {
                this.loading_otp = true
                this.phone_error = false
                this.clickShowModal && this.clickShowModal()
                //this.$bvModal.show('modal-cmnd')	
            }else{
                this.loading_otp = false
            }
        },
        focusMoney(){
            document.getElementById("price").focus();
        },
        formatMoney() {
            var x = this.form.money.replace(/\D/g, '').match(/(\d{0,2})/)
            this.form.money = x[1]
        },
        showText(){
            document.getElementById("show_text").innerHTML = 'Lưu ý: sử dụng thuê bao Viettel sẽ có thời gian duyệt vay nhanh hơn';
            document.getElementById("show_text").classList.add("bg-red-300");
            setTimeout( () => {
                document.getElementById("show_text").innerHTML = ''
                document.getElementById("show_text").classList.remove("bg-red-300");
            }, 3000)
        },
        formatPhone() {
            if(this.form.phone.substring(0, 2) == '84'){
                var x = this.form.phone.replace(/\D/g, '').match(/(\d{0,5})(\d{0,3})(\d{0,3})/)
                this.form.phone = !x[2] ? x[1] : '' + x[1] + '' + x[2] + (x[3] ? '' + x[3] : '')
                if( this.form.phone.length > 2 && !/(84)+[3|5|7|8|9]\b/.test(this.form.phone.substring(0, 3))){
                    this.phone_error = true
                } else {
                     this.phone_error = false
                }
            } else {
                var x = this.form.phone.replace(/\D/g, '').match(/(\d{0,4})(\d{0,3})(\d{0,3})/)
                this.form.phone = !x[2] ? x[1] : '' + x[1] + '' + x[2] + (x[3] ? '' + x[3] : '')
                if( this.form.phone.length > 1 && !/(0)+[3|5|7|8|9]\b/.test(this.form.phone.substring(0, 2))){
                    this.phone_error = true
                } else {
                    this.phone_error = false
                }
            }
            this.phone_error != /(84|0)+[3|5|7|8|9]+([0-9]{8})\b/.test(this.form.phone.replaceAll(' ',''))
            this.checkPhone = /(84|0)+[3|5|7|8|9]+([0-9]{8})\b/.test(this.form.phone.replaceAll(' ',''))
            if(this.click_check){
                if(this.checkPhone){
                    this.phone_error = false
                } else {
                    this.phone_error = true
                }
            }
        },
    },

}
</script>

<style>
[data-tip] {
	position:relative;

}
[data-tip]:before {
	content:'';
	/* hides the tooltip when not hovered */
	display:none;
	content:'';
	border-left: 5px solid transparent;
	border-right: 5px solid transparent;
	border-bottom: 5px solid #dfbd60;	
	position:absolute;
	top:10px;
	right:35px;
	z-index:8;
	font-size:0;
	line-height:0;
	width:0;
	height:0;
}
[data-tip]:after {
	display:none;
	content:attr(data-tip);
	position:absolute;
	top:15px;
	right:0px;
	padding:5px 8px;
	background:#dfbd60;
	color:#fff;
	z-index:9;
	font-size: 0.95em;
	height:30px;
	line-height:22px;
	-webkit-border-radius: 3px;
	-moz-border-radius: 3px;
	border-radius: 3px;
	white-space:nowrap;
	word-wrap:normal;
}
[data-tip]:focus:before + div,
[data-tip]:focus:after + div {
	display:block;
}
</style>